import React from "react";
import navigationConfig from "configs/navigationConfig";
import startCase from "lodash/startCase";

export const addSquare = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
      <path d="M6 9H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 12V6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <path
      d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const exportIcon1 = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.5" d="M20.75 10.25L18.5 12.5M20.75 10.25L18.5 8M20.75 10.25H16.65C14.41 10.25 13.29 10.25 12.434 10.686C11.6814 11.0695 11.0695 11.6814 10.686 12.434C10.25 13.29 10.25 14.41 10.25 16.65V17" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path opacity="0.5" d="M3.93 8.50018H7.25C7.51522 8.50018 7.76957 8.39482 7.95711 8.20728C8.14464 8.01975 8.25 7.76539 8.25 7.50018V4.18018C7.877 4.35018 7.598 4.65218 7.313 4.93718L4.687 7.56318C4.402 7.84818 4.099 8.12718 3.93 8.50018" fill="white"/>
  <path d="M3.93 8.50018H7.25C7.51522 8.50018 7.76957 8.39482 7.95711 8.20728C8.14464 8.01975 8.25 7.76539 8.25 7.50018V4.18018C7.877 4.35018 7.598 4.65218 7.313 4.93718L4.687 7.56318C4.402 7.84818 4.099 8.12718 3.93 8.50018" fill="white"/>
  <path d="M16.5 10.0001C16.5 10.199 16.421 10.3897 16.2803 10.5304C16.1397 10.671 15.9489 10.7501 15.75 10.7501C15.5511 10.7501 15.3603 10.671 15.2197 10.5304C15.079 10.3897 15 10.199 15 10.0001H16.5ZM15 14.0001C15 13.8012 15.079 13.6104 15.2197 13.4697C15.3603 13.3291 15.5511 13.2501 15.75 13.2501C15.9489 13.2501 16.1397 13.3291 16.2803 13.4697C16.421 13.6104 16.5 13.8012 16.5 14.0001H15ZM3.93 8.50007V9.25007C3.80454 9.25008 3.68107 9.21861 3.57092 9.15856C3.46076 9.0985 3.36743 9.01176 3.29948 8.9063C3.23152 8.80083 3.19111 8.68 3.18194 8.55487C3.17277 8.42974 3.19514 8.30431 3.247 8.19007L3.93 8.50007ZM8.25 4.18007L7.94 3.49707C8.05424 3.44521 8.17967 3.42284 8.3048 3.43201C8.42993 3.44117 8.55076 3.48159 8.65623 3.54954C8.7617 3.6175 8.84843 3.71083 8.90849 3.82098C8.96855 3.93114 9.00001 4.0546 9 4.18007H8.25ZM6.95 19.2501H12.55V20.7501H6.95V19.2501ZM12.55 4.75007H9.575V3.25007H12.55V4.75007ZM4.5 9.82507V16.8001H3V9.82507H4.5ZM7.843 5.46707L5.218 8.09307L4.157 7.03307L6.782 4.40707L7.843 5.46707ZM15 10.0001V7.20007H16.5V10.0001H15ZM15 16.8001V14.0001H16.5V16.8001H15ZM5.218 8.09307C4.846 8.46407 4.751 8.56707 4.684 8.67507L3.405 7.89207C3.586 7.59607 3.836 7.35407 4.157 7.03307L5.218 8.09307ZM6.782 4.40707C7.103 4.08707 7.346 3.83707 7.642 3.65507L8.425 4.93507C8.317 5.00107 8.215 5.09507 7.843 5.46707L6.782 4.40707ZM9.575 4.75007C8.998 4.75007 8.698 4.76807 8.425 4.93507L7.642 3.65507C8.329 3.23507 9.059 3.25007 9.576 3.25007L9.575 4.75007ZM3 9.82507C3 9.30907 2.984 8.57907 3.405 7.89207L4.684 8.67507C4.516 8.94807 4.5 9.24807 4.5 9.82507H3ZM3.93 7.75007H7.25V9.25007H3.93V7.75007ZM7.5 7.50007V4.18007H9V7.50007H7.5ZM7.25 7.75007C7.3163 7.75007 7.37989 7.72373 7.42678 7.67684C7.47366 7.62996 7.5 7.56637 7.5 7.50007H9C9 8.46607 8.216 9.25007 7.25 9.25007V7.75007ZM8.56 4.86207C8.34 4.96207 8.169 5.14107 7.843 5.46707L6.783 4.40707C7.028 4.16107 7.414 3.73707 7.94 3.49707L8.56 4.86207ZM5.218 8.09307C4.892 8.41907 4.713 8.59007 4.612 8.81107L3.247 8.19007C3.487 7.66507 3.911 7.27907 4.157 7.03307L5.218 8.09307ZM12.55 19.2501C13.679 19.2501 14.216 19.0631 14.502 18.7871C14.782 18.5171 15 17.9871 15 16.8001H16.5C16.5 18.0841 16.282 19.1541 15.543 19.8661C14.811 20.5731 13.748 20.7501 12.55 20.7501V19.2501ZM4.5 16.8001C4.5 17.9291 4.687 18.4661 4.963 18.7521C5.233 19.0321 5.763 19.2501 6.95 19.2501V20.7501C5.666 20.7501 4.596 20.5321 3.884 19.7931C3.177 19.0611 3 17.9981 3 16.8001H4.5ZM15 7.20007C15 6.07107 14.813 5.53407 14.537 5.24807C14.267 4.96807 13.737 4.75007 12.55 4.75007V3.25007C13.834 3.25007 14.904 3.46807 15.617 4.20707C16.323 4.93907 16.5 6.00207 16.5 7.20007H15Z" fill="white"/>
  </svg>
);

export const notification = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0201 20.53C9.69011 20.53 7.36011 20.16 5.15011 19.42C4.31011 19.13 3.67011 18.54 3.39011 17.77C3.10011 17 3.20011 16.15 3.66011 15.39L4.81011 13.48C5.05011 13.08 5.27011 12.28 5.27011 11.81V8.91998C5.27011 5.19998 8.30011 2.16998 12.0201 2.16998C15.7401 2.16998 18.7701 5.19998 18.7701 8.91998V11.81C18.7701 12.27 18.9901 13.08 19.2301 13.49L20.3701 15.39C20.8001 16.11 20.8801 16.98 20.5901 17.77C20.3001 18.56 19.6701 19.16 18.8801 19.42C16.6801 20.16 14.3501 20.53 12.0201 20.53ZM12.0201 3.66998C9.13011 3.66998 6.77011 6.01998 6.77011 8.91998V11.81C6.77011 12.54 6.47011 13.62 6.10011 14.25L4.95011 16.16C4.73011 16.53 4.67011 16.92 4.80011 17.25C4.92011 17.59 5.22011 17.85 5.63011 17.99C9.81011 19.39 14.2401 19.39 18.4201 17.99C18.7801 17.87 19.0601 17.6 19.1901 17.24C19.3201 16.88 19.2901 16.49 19.0901 16.16L17.9401 14.25C17.5601 13.6 17.2701 12.53 17.2701 11.8V8.91998C17.2701 6.01998 14.9201 3.66998 12.0201 3.66998Z"
      fill="#51459E"
    />
    <path
      d="M13.8801 3.93999C13.8101 3.93999 13.7401 3.92999 13.6701 3.90999C13.3801 3.82999 13.1001 3.76999 12.8301 3.72999C11.9801 3.61999 11.1601 3.67999 10.3901 3.90999C10.1101 3.99999 9.81011 3.90999 9.62011 3.69999C9.43011 3.48999 9.37011 3.18999 9.48011 2.91999C9.89011 1.86999 10.8901 1.17999 12.0301 1.17999C13.1701 1.17999 14.1701 1.85999 14.5801 2.91999C14.6801 3.18999 14.6301 3.48999 14.4401 3.69999C14.2901 3.85999 14.0801 3.93999 13.8801 3.93999Z"
      fill="#51459E"
    />
    <path
      d="M12.02 22.81C11.03 22.81 10.07 22.41 9.37002 21.71C8.67002 21.01 8.27002 20.05 8.27002 19.06H9.77002C9.77002 19.65 10.01 20.23 10.43 20.65C10.85 21.07 11.43 21.31 12.02 21.31C13.26 21.31 14.27 20.3 14.27 19.06H15.77C15.77 21.13 14.09 22.81 12.02 22.81Z"
      fill="#51459E"
    />
  </svg>
);

export const toggleDrop = (
  <svg width="24" height="24" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#F2F2F2"
    />
    <path
      d="M12 15.01C11.81 15.01 11.62 14.94 11.47 14.79L7.93997 11.26C7.64997 10.97 7.64997 10.49 7.93997 10.2C8.22997 9.91001 8.70997 9.91001 8.99997 10.2L12 13.2L15 10.2C15.29 9.91001 15.77 9.91001 16.06 10.2C16.35 10.49 16.35 10.97 16.06 11.26L12.53 14.79C12.38 14.94 12.19 15.01 12 15.01Z"
      fill="#F2F2F2"
    />
  </svg>
);

export const addIcon = (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dd_262_20562)">
      <circle cx="31" cy="27" r="14" fill="#1A355E" />
    </g>
    <path d="M28 27H34" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M31 30V24" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <defs>
      <filter
        id="filter0_dd_262_20562"
        x="0.804442"
        y="0.573308"
        width="54.8889"
        height="54.8889"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.625253" dy="0.231307" />
        <feGaussianBlur stdDeviation="3.24653" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.780392 0 0 0 0 0.815686 0 0 0 0 1 0 0 0 0.0240741 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_262_20562" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.75111" dy="1.01775" />
        <feGaussianBlur stdDeviation="6.72222" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.780392 0 0 0 0 0.815686 0 0 0 0 1 0 0 0 0.0392593 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_262_20562" result="effect2_dropShadow_262_20562" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_262_20562" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const getPageTitle = ({ pathName, query: pQuery }) => {
  let query = pQuery;
  let currentPageName = null;
  const splittedPaths = pathName?.split("/");
  navigationConfig.map((item) => {
    if (item.type === "collapse") {
      item.children.map((sItem) => {
        if (sItem.navLink === pathName) {
          currentPageName = sItem?.pageTitle;
        }
        return sItem;
      });
    } else if (item.navLink === pathName) {
      currentPageName = item?.pageTitle;
    }
    return item;
  });
  // preventive
  if (!currentPageName && query) {
    query = query?.workOrderId ? "workOrderDetail" : query;

    if (query === "workOrderDetail") {
      currentPageName = "Work Order - Details";
    }
    if (query?.comparisonID) {
      currentPageName = "Dashboard";
    } else if (splittedPaths?.includes("work-order-create")) {
      currentPageName = "Inventories";
    }else if (splittedPaths?.includes("ai-assistant")) {
      currentPageName = "AI Assistant";
    }
  } else if (!currentPageName) {
    currentPageName = "No PageName";
  }

  let routeName = splittedPaths.filter((i) => i);
  if (!currentPageName && routeName.length) {
    return startCase(routeName[0])
  }

  return currentPageName;
};
